import React from 'react'
import Collapsible from 'react-collapsible';
import Dropdown from '../Dropdown';
import PortalModal from './PortalModal'
import Border from '../Border'
import ColorPicker from '../ColorPicker';
import FontSelect from '../FontSelect';
import Toggle from '../sectioninputs/Toggle';
import Color from '../../utils/Color'
import General from '../../utils/General'
import Backend from '../../utils/Backend'
import Notify from "../../utils/Notify";
import Fonts from "../../utils/Fonts"
import Event from "../../utils/Event";
import LinkSelect from "../LinkSelect";

let OPTIONS_WEBSITE_DESIGN_STYLES = [
  {
    value: "flat",
    label: "Normal Flat Style"
  },
  {
    value: "card",
    label: "Card Style"
  }
]

let OPTIONS_BUTTON_STYLES = [
  {
    value: "square",
    label: "Square (no rounding)"
  },
  {
    value: "standard",
    label: "Lightly Rounded Rectangle"
  },
  {
    value: "rounded",
    label: "Fully Rounded Rectangle"
  },
]

let OPTIONS_MENU_STYLES = [
  {
    value: "bar",
    label: "Standard Menu With Buttons & Logo"
  },
  {
    value: "hamburger",
    label: "Hamburger Menu"
  },
]

export default class WebsiteModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show: props.show,
      page: props.page,
      menu: props.menu,
      website: window.CURRENT_WEBSITE
    }
  }

  componentDidMount() {
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _updateMSC = General.debounce((color, website, page, menu) => {
    website.primary_color = color
    window.CURRENT_PAGE_PRIMARY_COLOR = color
    window.CURRENT_PAGE_PRIMARY_COLOR_DARKENED = Color.brightness(window.CURRENT_PAGE_PRIMARY_COLOR, -20)

    if(menu.primary_logo){
      menu.primary_logo.icon_color = color
      menu.primary_logo.text_color = color
    }

    website = this._resetMSC(website)
    page = this._resetMSC(page)
    menu = this._resetMSC(menu)

    this.props.onUpdated(website)
    this.props.onPageSoftUpdated(page)
    this.props.onMenuSoftUpdated(menu)
  }, 1000, false)

  _onFontChange(e){
    var files = e.target.files;
    var filesArr = Array.prototype.slice.call(files);
    let file = filesArr[0]


    this.setState({ loading: true })
    Backend.uploadFont(file)
    .then(font => {
      this.setState({
        loading: false
      })
      Fonts.addUploaded(font)
      console.log("f", window.FONTS)
      this.props.onUpdated(this.state.website)
      Notify.success("Font Uploaded Successfully!")
    })
    .catch(error => {
      this.setState({
         loading: false
      })
      Notify.success(error.message)
    })
  }

  _resetMSC(obj){
    if(!obj){
      return obj
    }

    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'object') {
            return this._resetMSC(obj[key]);
        }
        if(key === "msc_enabled"){
          obj[key] = true;
        }
    });

    return obj
  }

  _renderTextSettings(name, key, borderComponentClass){
    let { website } = this.state
    website[key] = website[key] || {}
    let settings = website[key]

    let font = FontSelect.getOption(settings.family_name)
    let weights = []
    if(font){
      weights = font.weights.map(weight => {
        return {
          label: weight.name,
          value: weight.value,
          className: `${font.className} ${font.className}-${weight.value}`
        }
      })
    }

    let selectedWeight = weights.find(weight => weight.value === settings.weight)


    return (
      <Border darkMode={false} className={borderComponentClass || ""}>

        <div className="row">
          <div className="col">

            <span>{ name }</span>
            <FontSelect
              value={settings.family_name}
              onUpdated={value => {
                website[key].family_name = value
                this.setState({ website })
                this.props.onUpdated(website)
              }}
            />
            <br></br>
            <span>Font Thickness</span>
            <Dropdown
                options={weights}
                value={selectedWeight}
                onChange={option => {
                  website[key].weight = option.value
                  this.setState({ website })
                  this.props.onUpdated(website)
                }}
                placeholder="Thickness"
                className="font-select"
                placeholderClassName={font ? `${font.className} ${font.className}-${settings.weight}` : null}
            />

          </div>
        </div>

      </Border>
    )
  }

  _renderSectionWebsiteDesignStyle(){
    let { website } = this.state

    let selectedWebsiteDesignStyle = OPTIONS_WEBSITE_DESIGN_STYLES.find(websiteDesignStyle => websiteDesignStyle.value === website.design_style )

    return (
      <Border>

        <Collapsible
          trigger="Website Design Style"
        >
          <br/>
          <span>What design / style would you like</span>
          <Dropdown
              options={OPTIONS_WEBSITE_DESIGN_STYLES}
              value={selectedWebsiteDesignStyle}
              onChange={option => {
                website.design_style = option.value
                this.props.onUpdated(website)
                window.CURRENT_WEBSITE_DESIGN_STYLE = option.value
                if( option.value === "card"){
                  window.IS_CARD_STYLE_WEBSITE = true
                } else {
                  window.IS_CARD_STYLE_WEBSITE = false
                }
                this.setState({ website }, () =>
                  {
                    General.updateHomePagePaddingTop()
                    General.updateBlockAnimateOnScroll()
                  }
                )
              }}
              placeholder="Select An Option"
          />
          <br />
          <ColorPicker
            title={ "Website Background Color" }
            color={ window.CURRENT_WEBSITE_BACKGROUND_COLOR }
            onColorSelected={color => {
              website.background_color = color;
              this.setState({ website })
              this.props.onUpdated(website);
              window.CURRENT_WEBSITE_BACKGROUND_COLOR = color;
            }}
          />
        </Collapsible>

      </Border>
    )
  }

  _checkoutSettings() {
    let { website } = this.state

    let OPTIONS = [
      {
        value: "instant",
        label: "Instant Checkout"
      },
      {
        value: "cart",
        label: "Cart Based Checkout"
      },
      {
        value: "instantAndCart",
        label: "Instant and Cart Based Checkout"
      }
    ]
    return (
      <Border>
        <Collapsible trigger={`Checkout`}>
          <br/>
          <span>Checkout experience</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(mode => mode.value === (website?.checkout_type || "cart"))}
            onChange={option => {
              website.checkout_type = option.value;
              this.setState({ website });
              this.props.onUpdated(website);
            }}
            placeholder="Select An Option"
          />
          <br/>
          <span>Link your checkout page</span>
          <LinkSelect
            type={"shop"}
            checkoutOnly={true}
            url={website?.extra?.product_page_settings?.checkout_url || ""}
            onUpdated={url => {
              website.extra = website.extra || {};
              website.extra.product_page_settings = website.extra.product_page_settings || {};
              website.extra.product_page_settings.checkout_url = url;
              this.setState({ website });
              this.props.onUpdated(website);
            }}
          />
        </Collapsible>
      </Border>
    )
  }

  _tileSettings() {
    let { website } = this.state

    return (
      <Border>
        <Collapsible
          trigger={`Product Tile`}
        >
          <br/>
          <Toggle
            id="description_toggle"
            checked={website?.extra?.product_page_settings?.show_description || false}
            title="Description"
            onChange={checked => {
              website.extra.product_page_settings.show_description = checked;
              this.setState({ website })
              this.props.onUpdated(website)
            }}
          />
        </Collapsible>
      </Border>
    )
  }
  _renderSectionButton(){
    let { website } = this.state

    let selectedButtonStyle = OPTIONS_BUTTON_STYLES.find(buttonStyle => buttonStyle.value === website.button_style )

    return (
      <Border>

        <Collapsible
          trigger="Button Style"
        >
          <br/>
          <span>What style of buttons would you like</span>
          <Dropdown
              options={OPTIONS_BUTTON_STYLES}
              value={selectedButtonStyle}
              onChange={option => {
                website.button_style = option.value
                this.setState({ website })
                this.props.onUpdated(website)
              }}
              placeholder="Select An Option"
          />
        </Collapsible>

      </Border>
    )
  }

  _renderSectionFonts(){
    return (
      <Border>
        <Collapsible
          trigger="Fonts"
        >
          <br/>
          {/* <div className="custom-file upload-my-font">
            <a
              href="javascript:void(0);"
              class="btn btn-block btn-outline-dark"
            >
              <span class="btn__text">Upload New Font</span>
            </a>
            <input
              type="file"
              className="custom-file-input"
              accept=".ttf,.otf,.eot,.woff,.woff2"
              onChange={e => this._onFontChange(e)}
            />
          </div> */}
          { this._renderTextSettings("Main Banner Large Title Font", "h1_font", "mt-0") }
          { this._renderTextSettings("Other Smaller Headings Fonts", "h2_font") }
          { this._renderTextSettings("Menu Font", "menu_font") }
          { this._renderTextSettings("Default Text Font", "p_font") }
          { this._renderTextSettings("Subtitle (H3)", "h3_font") }
          { this._renderTextSettings("Sub Header (H4)", "h4_font") }
          { this._renderTextSettings("Small Sub Header (H5)", "h5_font") }
          { this._renderTextSettings("Buttons", "btn_font") }
        </Collapsible>
      </Border>
    )
  }

  _renderSectionNavToggles(){
    let { website, menu } = this.state

    let selectedMenuStyle = OPTIONS_MENU_STYLES.find(headerStyle => {
      return headerStyle.value === (menu.style || "bar")
    })

    return (
      <Border>
        <Collapsible
          trigger="Menu & Header & Footer"
        >
          <br/>
          <Toggle
            id="header_toggle"
            checked={!website.hide_menu}
            title="Header & Menu Enabled"
            onChange={checked => {
              website.hide_menu = !checked
              this.props.onUpdated(website)
            }}
          />

          {!website.hide_menu &&
            <>
              <span>
                Menu Style
              </span>
              <Dropdown
                options={OPTIONS_MENU_STYLES}
                value={selectedMenuStyle}
                onChange={option => {
                  menu.style = option.value
                  this.setState({ menu })
                  this.props.onMenuUpdated(menu)
                  if(option.value === "hamburger"){
                    General.updateModals()
                  }
                }}
                placeholder="Menu Style"
              />
              <br/><br/>
            </>
          }

          <Toggle
            id="footer_toggle"
            checked={!website.hide_footer}
            title="Footer Enabled"
            onChange={checked => {
              website.hide_footer = !checked
              this.props.onUpdated(website)
            }}
          />
        </Collapsible>
      </Border>
    )
  }

  _renderSectionDetails(){

    let { website } = this.state

    return (
      <Border>
          <Collapsible
            trigger="Info"
          >
            <br/>
            <span>
              Website Name
            </span>
            <input
              type="text"
              defaultValue={ website.name }
              onChange={e => {
                website.name = e.target.value
                this.setState({ website })
                this.props.onUpdated(website)
              }}
            />

            <br/><br/>

            <span>
              Tag Line
            </span>
            <input
              type="text"
              defaultValue={ website.tag_line }
              onChange={e => {
                website.tag_line = e.target.value
                this.setState({ website })
                this.props.onUpdated(website)
              }}
            />
        </Collapsible>
      </Border>
    )
  }

  render() {
    let {
      show,
      page,
      menu,
      website
     } = this.state

     if(!website || !menu){
       return null
     }

     return (
      <PortalModal
        show={show}
        loadSideMenuFromLeft="true"
        onHide={() => this.props.onHide()}
        disableBodyScroll={true}
      >
        <h2 className="mb-0">
          Main Style Settings
        </h2>
        <label className="mb-5">Adjust your website's core style</label>

        { this._renderSectionWebsiteDesignStyle() }
        { this._checkoutSettings() }
        { this._tileSettings() }
        { this._renderSectionButton() }
        { this._renderSectionFonts() }
        { this._renderSectionNavToggles() }
        { this._renderSectionDetails() }

      </PortalModal>
    )
  }
}
